export default "__VITE_ASSET__ArWRnC_T__"